import React, { useState } from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  TelegramShareButton,
  ViberShareButton,
  FacebookMessengerShareButton,
  WhatsappShareButton,
} from "react-share";
import {
  FacebookIcon,
  WhatsappIcon,
  EmailIcon,
  FacebookMessengerIcon,
  TelegramIcon,
  ViberIcon,
} from "react-share";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import the styles
import { Container, Col, Row } from "react-bootstrap";
import axios from "axios";

const convertDate = (date) => {
  const [year, month, day] = date.split("-");
  return [day, month, year].join("/");
};

function BigUmrlica({ post, modalIsOpen }) {
  const [imageSrc, setImageSrc] = useState(require("../assets/candle.png"));
  const userRole = localStorage.getItem("userRole");
  const [counter, setCounter] = useState(post.counter);

  const deletePosts = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.delete(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      window.location.href = "/";
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const handleCandleClick = () => {
    // Toggle between two image sources
    if (imageSrc === require("../assets/candle.png")) {
      setImageSrc(require("../assets/candleColor.png"));
      increaseCounter();
    }
  };
  const increaseCounter = async () => {
    try {
      setCounter(post.counter + 1);
      await axios.post(
        `https://radojicictijanaa.pythonanywhere.com/api/posts/${post.id}/counter/up/`,
        {}
      );
    } catch (error) {
      console.log("Error fetching posts:", error);
    }
  };

  const customStyle = {
    border: `5px solid ${
      post && post.color === "blue"
        ? "blue" // Use the specific color for "blue"
        : post.color === "green" ||
          post.color === "black" ||
          post.color === "red"
        ? post.color // Use other colors for "green," "black," or "red"
        : "black" // Default color for other cases
    }`,
    backgroundColor: "white",
    marginTop: "20px",
    width: "100%",
  };

  return (
    <Container
      id={`post-${post.id}`}
      className="post"
      style={customStyle}
      data-aos="fade-up"
    >
      {" "}
      <Row
        style={{
          fontStyle: "italic",
          border: "none",
          borderTop: "none",
          display: "flex",
          justifyContent: "end",
          paddingRight: "1rem",

          backgroundColor: "transparent",
          color: "gray",
          fontSize: "16px",
        }}
      >
        {post.type}
      </Row>
      <Row style={{ paddingTop: "1%" }}>
        <p style={{ paddingRight: "10%" }}>{post.text_top}</p>
      </Row>
      <Col
        style={{ marginTop: "30px" }}
        className="d-flex justify-content-center"
      >
        <img
          id="umrlica-icon"
          style={{
            height: "50px",
            width: "50px",
            border: "none",
          }}
          src={post.icon}
          alt="x"
        />
      </Col>
      <Row style={{ paddingTop: "2%" }}>
        <Col className="d-flex justify-content-around">
          {post.images.length !== 0 && (
            <Carousel
              showThumbs={false}
              showArrows={false}
              infiniteLoop={true}
              autoPlay={true}
              interval={2500}
            >
              {post.images
                .reduce((p, c) => p + c)
                .split(",")
                .map((imagePath, index) => (
                  <div className="d-flex justify-content-center" key={index}>
                    <div
                      style={{
                        width: "120px",
                        height: "150px",
                        border: "3px solid black",
                        background: `url(https://radojicictijanaa.pythonanywhere.com/${imagePath})`,
                        backgroundSize: "cover",
                        backgroundPosition: "50% 50%",
                      }}
                    ></div>
                  </div>
                ))}
            </Carousel>
          )}

          {post.images.length === 0 && (
            <div
              style={{
                width: "150px",
                height: "150px",
              }}
            ></div>
          )}
        </Col>
      </Row>
      <Row style={{ paddingTop: "2%" }}>
        <Col
          style={{
            fontWeight: "bold",
            letterSpacing: "1.2px",
            fontSize: "larger",
          }}
          className="d-flex justify-content-around"
        >
          {post.name}
        </Col>
      </Row>
      <Col className="d-flex justify-content-around">
        <span style={{ textAlign: "center" }}>
          {convertDate(post.birth_date)} - {convertDate(post.death_date)}
        </span>
      </Col>
      <Row style={{ paddingTop: "2%" }}>
        <p>{post.main_text}</p>
      </Row>
      {modalIsOpen && (
        <Row>
          {" "}
          <span style={{ textAlign: "center" }}>Upali svijeću</span>
        </Row>
      )}
      {modalIsOpen && (
        <Row>
          {" "}
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              alignItems: "center",
              borderRadius: "100%",
            }}
            onClick={handleCandleClick}
          >
            <img src={imageSrc} alt="Image" />
          </button>
        </Row>
      )}
      {modalIsOpen && (
        <Row style={{ paddingBottom: "0" }}>
          {" "}
          <span style={{ textAlign: "center" }}>{counter}</span>
        </Row>
      )}
      <hr></hr>
      <Row style={{ padding: "2%", paddingLeft: "0" }}>
        <b>
          <h5 id="sakrij">Ožalošćeni:</h5>
          <p id="sakrij">{post.text_bottom}</p>
        </b>
      </Row>
      {modalIsOpen && (userRole === "admin" || userRole === "superadmin") && (
        <Col>
          <button className="btn btn-danger" onClick={() => deletePosts()}>
            Obriši
          </button>
        </Col>
      )}
      {!modalIsOpen && (
        <div className="predaj-pp-button">Predaj poslednji pozdrav</div>
      )}
      {modalIsOpen && (
        <div
          style={{ float: "right", paddingBottom: "2%", paddingRight: "1%" }}
        >
          <FacebookShareButton
            title="Facebook"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookShareButton>
          <span title="Viber">
            <ViberShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <ViberIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </ViberShareButton>
          </span>
          <EmailShareButton
            title="Email"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            subject="Check out this post"
          >
            <EmailIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </EmailShareButton>
          <FacebookMessengerShareButton
            title="Messenger"
            url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
          >
            <FacebookMessengerIcon
              bgStyle={{ fill: "black" }}
              iconFillColor="white"
              size={25}
              round
            />
          </FacebookMessengerShareButton>
          <span title="Telegram">
            <TelegramShareButton
              title="Telegram"
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
            >
              <TelegramIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </TelegramShareButton>
          </span>
          <span title="What's App">
            <WhatsappShareButton
              url={`https://project-vijesti-1.vercel.app/posts/${post.id}`}
              title="Check out this post"
            >
              <WhatsappIcon
                bgStyle={{ fill: "black" }}
                iconFillColor="white"
                size={25}
                round
              />
            </WhatsappShareButton>
          </span>
        </div>
      )}
    </Container>
  );
}

export default BigUmrlica;
